import type { TeacherWorkload } from 'shared/api';
import type { TeacherWorkloadsTableRow } from '../types';

export const toTeacherWorkloadsTableRows = (
  workloads: TeacherWorkload[],
): TeacherWorkloadsTableRow[] =>
  workloads.flatMap((workload) => {
    const qualifications = workload.qualifications ?? [];
    const qualificationsCount = Math.max(qualifications.length, 1);

    if (qualifications.length === 0) {
      return [
        {
          key: `${workload.id}_0`,
          teacherWorkload: workload,
          code: workload.code,
          rooms: workload.rooms,
          qualificationIndex: 0,
          qualificationsCount,
        },
      ];
    }

    return qualifications.map((qualification, index) => ({
      key: `${workload.id}_${index}`,
      teacherWorkload: workload,
      code: workload.code,
      rooms: workload.rooms,
      qualification,
      qualificationIndex: index,
      qualificationsCount,
    }));
  });
